// extracted by mini-css-extract-plugin
module.exports = {"CookieBanner":"styles_CookieBanner__2Puwl","CookieBanner_text":"styles_CookieBanner_text__2tHg6","CookieBanner_button":"styles_CookieBanner_button__3uxwQ"};